// extracted by mini-css-extract-plugin
export default {"root":"DataSources_root__nwaWN","item":"DataSources_item__keLa4","wrapper":"DataSources_wrapper__pqFcz","portalWrapper":"DataSources_portalWrapper__-1PRQ"};